import styled, { css } from 'styled-components'

import { Text } from '@h2/components/typography/text'
import { PB, SLB, WHITE } from '@h2/components/colors'
import { Page } from '@h2/common/components/page'
import { Heading } from '@h2/components/typography/heading'
import { museoFont } from '@h2/components/mixins'
import { Link } from '@h2/common/components/link'
import { Button } from '@h2/components/buttons/button'
import { features } from '@h2/components/media'

const StyledContent = styled(Page.Content)`
  border: ${SLB} solid 20px;
  border-style: solid;
  border-width: ${({ isEarlyLearnerMode }) => (isEarlyLearnerMode ? '20px' : '0')};
  border-color: ${({ isEarlyLearnerMode }) => (isEarlyLearnerMode ? SLB : 'transparent')};
  border-radius: 55px;
  padding: ${({ isEarlyLearnerMode }) => (isEarlyLearnerMode ? '60px' : '25px')};
`
const MuseoHeading = styled(Heading)`
  ${museoFont}
  font-weight: 900;

  > span {
    font-weight: 500;
  }
`
const MuseoText = styled(Text)`
  ${museoFont}
  font-weight: 500;
`
const pillStyles = css`
  ${museoFont}
  font-weight: 900;
  background-color: ${SLB};
  border-radius: 25px;

  @media (${features.minWidth.desktop}) {
    width: 280px;
  }

  :hover {
    background-color: ${WHITE};
    color: ${PB};
    outline: ${SLB} solid 3px;
    transition: outline 300ms;
  }
`
const PillLink = styled(Link).attrs({ size: 'large', variant: 'button' })`
  ${pillStyles}
`
const PillButton = styled(Button).attrs({
  size: 'large',
  align: 'center'
})`
  ${pillStyles}
`
const PillOutlineLink = styled(Link)`
  ${museoFont}
  font-weight: 900;
  background-color: ${WHITE};
  color: ${SLB};
  z-index: 1;
  border-radius: 25px;
  outline: ${SLB} solid 1px;

  @media (${features.minWidth.desktop}) {
    width: 280px;
  }

  :link,
  :visited {
    color: ${SLB};
    background-color: ${WHITE};
    border-color: ${SLB};
  }

  :hover {
    color: ${WHITE};
    background-color: ${SLB};
    outline: ${SLB} solid 2px;
    transition: outline 300ms;
  }
`

export { StyledContent, MuseoHeading, MuseoText, PillLink, PillOutlineLink, PillButton }
